import React from 'react';
import 'fragments/announcements/announcement-compose.scss';
import { Button, Input, Switch } from 'antd';
import { CloseOutlined, WifiOutlined } from '@ant-design/icons';
import { useTranslator } from 'tools/view-hooks/translator-hook';
import { useAnnouncementComposeController } from 'fragments/announcements/announcement-compose.controller';

const { TextArea } = Input;

export const AnnouncementComposeFragment: React.FC = () => {
    const { translate } = useTranslator();
    const { state, events } = useAnnouncementComposeController();

    const canPublish = !!state.title.trim() && !!state.body.trim() && !state.submitting;

    return (
        <div className={'announcement-compose'}>
            <div className={'announcement-compose-header'}>
                <h1 className={'announcement-compose-header-title'}>
                    {translate({ key: 'announcements.compose-title' })}
                </h1>
                <button
                    type={'button'}
                    className={'announcement-compose-close'}
                    aria-label={translate({ key: 'general.cancel' })}
                    onClick={events.onClose}
                >
                    <CloseOutlined aria-hidden />
                </button>
            </div>

            <div className={'announcement-compose-field'}>
                <label className={'announcement-compose-label'} htmlFor={'announcement-compose-title'}>
                    {translate({ key: 'announcements.field-title' })}
                </label>
                <Input
                    id={'announcement-compose-title'}
                    size={'large'}
                    status={state.titleError ? 'error' : undefined}
                    placeholder={translate({ key: 'announcements.field-title-ph' })}
                    value={state.title}
                    onChange={(e) => events.onTitle(e.target.value)}
                />
                {state.titleError && (
                    <span className={'announcement-compose-field-error'} role={'alert'}>
                        {state.titleError}
                    </span>
                )}
            </div>

            <div className={'announcement-compose-field'}>
                <label className={'announcement-compose-label'} htmlFor={'announcement-compose-body'}>
                    {translate({ key: 'announcements.field-message' })}
                </label>
                <TextArea
                    id={'announcement-compose-body'}
                    rows={5}
                    placeholder={translate({ key: 'announcements.field-message-ph' })}
                    value={state.body}
                    onChange={(e) => events.onBody(e.target.value)}
                />
            </div>

            <div className={'announcement-compose-toggle'}>
                <span className={'announcement-compose-toggle-text'}>
                    <span className={'announcement-compose-toggle-title'}>
                        {translate({ key: 'announcements.silent-toggle' })}
                    </span>
                    <span className={'announcement-compose-toggle-sub'}>
                        {translate({ key: 'announcements.silent-sub' })}
                    </span>
                </span>
                <Switch
                    checked={state.silent}
                    onChange={events.onToggleSilent}
                    aria-label={translate({ key: 'announcements.silent-toggle' })}
                />
            </div>

            <div className={'announcement-compose-cta'}>
                {state.error && (
                    <div className={'announcement-compose-snackbar'} role={'alert'}>
                        <WifiOutlined aria-hidden />
                        <span className={'announcement-compose-snackbar-text'}>{state.error}</span>
                        <button
                            type={'button'}
                            className={'announcement-compose-snackbar-retry'}
                            onClick={events.onPublish}
                        >
                            {translate({ key: 'announcements.retry' })}
                        </button>
                    </div>
                )}
                <Button
                    type={'primary'}
                    className={'announcement-compose-submit'}
                    loading={state.submitting}
                    disabled={!canPublish}
                    onClick={events.onPublish}
                >
                    {translate({ key: 'announcements.publish' })}
                </Button>
            </div>
        </div>
    );
};
